import { createContext } from 'react';
import noop from 'lodash/noop';

import api from '../api';
import { Language } from '../types';
import { Context } from '../../../types';

export default createContext<Context<Language>>({
    get: api.get,
    getById: api.getById,
    getSchema: api.getSchema,
    schema: {},
    post: api.post,
    put: api.put,
    data: [],
    setData: noop,
    selected: null,
    setSelected: noop,
    remove: api.remove,
    error: null
});
